import { render, staticRenderFns } from "./PeopleTadahiro.vue?vue&type=template&id=05c27dda&scoped=true&"
import script from "./PeopleTadahiro.vue?vue&type=script&lang=js&"
export * from "./PeopleTadahiro.vue?vue&type=script&lang=js&"
import style0 from "./PeopleTadahiro.vue?vue&type=style&index=0&id=05c27dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c27dda",
  null
  
)

export default component.exports